import { render } from "./AsahiInformationModal.vue?vue&type=template&id=e23fe28e&scoped=true&ts=true"
import script from "./AsahiInformationModal.vue?vue&type=script&lang=ts"
export * from "./AsahiInformationModal.vue?vue&type=script&lang=ts"

import "./AsahiInformationModal.vue?vue&type=style&index=0&id=e23fe28e&lang=scss&scoped=true"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e23fe28e"]])

export default __exports__